import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeNumeric } from '../traitTypes/TraitTypeNumeric';
export class TraitRegistryCssAnimation extends TraitRegistryCategory {
    label = 'CSS Animation';
    constructor(parent) {
        super(parent);
        super.init();
    }
    animationDuration = () => new TraitTypeNumeric( /*{
      label: 'Animationsdauer (ms)',
      min: 0,
      max: 5000
    }*/);
    animationDelay = () => new TraitTypeNumeric( /*{
      label: 'Animationsverzögerung (ms)',
      min: 0,
      max: 5000
    }*/);
    animationIterationCount = () => new TraitTypeSelect({
        default: '1'
        /*  label: 'Animations-Wiederholungen',
        select: [['infinite'], ['0'], ['1'], ['5']] */
    });
    animationDirection = () => new TraitTypeSelect( /*{
      label: 'Animationsrichtung',
      default: 'normal',
      select: [['normal'], ['reverse'], ['alternate'], ['alternate-reverse']]
    }*/);
    animationFillMode = () => new TraitTypeSelect( /*{
      label: 'Animation Füllmodus',
      default: 'none',
      init: 'both',
      select: [['none'], ['forwards'], ['backwards'], ['both']]
    }*/);
    animationName = () => new TraitTypeSelect( /*{
      label: 'CSS Animationsname',
      default: 'none',
      select: [['test']]
    }*/);
    animationPlayState = () => new TraitTypeSelect( /*{
      label: 'CSS Animation playstate',
      default: 'running',
      select: [['running'], ['paused']]
    }*/);
    animationTimingFunction = () => new TraitTypeSelect({
        default: 'ease'
        /*
       label: 'CSS Animationsfunktion',
        select: [
          ['ease'],
          ['ease-in'],
          ['ease-out'],
          ['ease-in-out'],
          ['linear'],
          ['step-start'],
          ['step-end'],
          ['cubic-bezier(0.1, 0.7, 1.0, 0.1)'],
          ['steps(4, end)']
        ]*/
    });
    backfaceVisibility = () => new TraitTypeSelect( /*{
      label: 'Rückseitensichtbarkeit',
      default: 'visible',
      init: 'hidden',
      select: [['visible'], ['hidden']]
    }*/);
}
